<template>
  <el-dialog
    :title="title"
    :visible="visible"
    :before-close="closeDialog"
    width="50%">
    <span v-if="isPreReceivedPage">提示: 仅统计已签收状态的预收款发票信息<br><br></span>
    <el-table :data="amountStatistics"
              stripe
              highlight-current-row
              border
              style="width: 100%">
      <template v-if="!isPreReceivedPage">
        <el-table-column prop="status"
                         label="状态"
                         key="status"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in options.status"
                  v-if="scope.row.status * 1 === item.value"
                  :style="{color: item.color}">{{item.label}}</span>
            <span v-if="scope.row.status * 1 === -1">总计</span>
          </template>
        </el-table-column>
        <el-table-column prop="length"
                         key="length"
                         label="开票笔数"
                         width="190">
          <template slot-scope="scope">
            {{scope.row.length}}
          </template>
        </el-table-column>
        <el-table-column prop="untaxed_amount"
                         label="未税金额汇总"
                         key="untaxed_amount"
                         width="190">
          <template slot-scope="scope">
            ￥{{scope.row.untaxed_amount | seperateThousandsToFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column prop="total"
                         label="含税金额汇总"
                         key="total"
                         width="190">
          <template slot-scope="scope">
            ￥{{scope.row.total | seperateThousandsToFixed(2)}}
          </template>
        </el-table-column>
      </template>

      <template v-if="isPreReceivedPage">
        <el-table-column prop="deduction_status"
                         label="抵扣状态"
                         key="deduction_status"
                         min-width="100">
          <template slot-scope="scope">
            <span v-for="item in options.deduction_status"
                  v-if="scope.row.deduction_status * 1 === item.value"
                  :style="{color: item.color}">{{item.label}}</span>
            <span v-if="scope.row.deduction_status * 1 === -1">总计</span>
          </template>
        </el-table-column>
        <el-table-column prop="length"
                         label="开票笔数"
                         key="deduction_length"
                         width="90">
          <template slot-scope="scope">
            {{scope.row.length}}
          </template>
        </el-table-column>
        <el-table-column prop="available_deduct_amount"
                         label="可用抵扣金额汇总"
                         key="available_deduct_amount"
                         width="190">
          <template slot-scope="scope">
            ￥{{scope.row.available_deduct_amount | seperateThousandsToFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column prop="freeze_deduct_amount"
                         label="冻结抵扣金额汇总"
                         key="freeze_deduct_amount"
                         width="190">
          <template slot-scope="scope">
            ￥{{scope.row.freeze_deduct_amount | seperateThousandsToFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column prop="deducted_amount"
                         label="已抵扣金额汇总"
                         key="deducted_amount"
                         width="190">
          <template slot-scope="scope">
            ￥{{scope.row.deducted_amount | seperateThousandsToFixed(2)}}
          </template>
        </el-table-column>
      </template>

    </el-table>
    <span slot="footer"
          class="dialog-footer" >
        <el-button @click="closeDialog">确认</el-button>
      </span>
  </el-dialog>
</template>

<script>

export default {
  components: {},
  props: {
    visible: Boolean,
    isPreReceivedPage: Boolean,
    title: String,
    amountStatistics: Array,
  },
  data () {
    return {}
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.invoiceApply.options,
    }),
  },
  watch: {},
  created () {},
  mounted () {},
  methods: {
    closeDialog () {
      this.$emit('closeDialog')
    }
  }
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/components/SumTaxedAmountDialog.vue